export default "__VITE_ASSET__f0f50877__"